import axios from 'axios';
import CryptoJS from 'crypto-js';

const getAPIKey = (payload) => {
  const key = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;
  return CryptoJS.HmacSHA1(payload, key).toString();
};

export const submitZentopiaDetails = async (data) => {
  const url = `/integrations/salesforce/userdetails`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data
    },
    headers: {
      'x-sf-integration-auth': `sha1=${getAPIKey(JSON.stringify(data))}`
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export async function apiCall(payload) {
  const {
    API_CALL,
    data,
    url,
    headers,
    extraPayload = {
      errorResponseRequired: false
    }
  } = payload;
  const API_URL = `${process.env.NEXT_PUBLIC_API_URL}${url}`;

  // Setting API parameters
  const apiParams = {
    ...API_CALL,
    ...data,
    url: API_URL,
    headers,
    withCredentials: false
  };
  try {
    // Make API call
    const apiResponse = await axios(apiParams);
    if (apiResponse.data) {
      // API call success
      return apiResponse.data;
    }
  } catch (err) {
    // API call failure
    return extraPayload.errorResponseRequired ? err.response : null;
    // Logging the error
  }
  return null;
}

export default submitZentopiaDetails;
